import {email, helpers, requiredIf} from "@vuelidate/validators";
import {EXTERNAL_APPEALS_PATIENT_RELATIONSHIPS} from "@/utils/constants.js";

export class ExternalAppealAuthorizedRepModel {
    constructor(data = {}) {
        this.authRepId = data.authRepId ?? null;
        this.appealId = data.appealId ?? null;
        this.fullName = data.fullName ?? null;
        this.phoneNumber = data.phoneNumber ?? null;
        this.email = data.email ?? null;
        this.createdAt = data.createdAt ?? null;
        this.updatedAt = data.updatedAt ?? null;
    }

    isEmpty() {
        return !this.fullName && !this.phoneNumber && !this.email;
    }

    toRequestPayload() {
        return {
            authRepId: this.authRepId,
            appealId: this.appealId,
            fullName: this.fullName,
            phoneNumber: this.phoneNumber,
            email: this.email,
            createdAt: this.createdAt,
            updatedAt: this.updatedAt,
        };
    }
}
